export const isWithinRange = (
  timestamp: Date | number | string,
  fromTime: Date | number | string | null,
  toTime: Date | number | string | null
) => {
  if (!fromTime || !toTime) return false;

  return (
    new Date(timestamp) >= new Date(fromTime) &&
    new Date(timestamp) <= new Date(toTime)
  );
};
